<template lang="html">
  <div id="bottom-tool">
    <router-link v-for="tool in tools" class="tool-item" :to="tool.link">
      <div class="iconfont" :class="tool.className"></div>
      <div class="text">{{ tool.text }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      tools: [
        { text: "首页", className: "icon-home", link: "/"},
        { text: "物流", className: "icon-deliver", link: "/deliver"},
        { text: "购物车", className: "icon-cart", link: "/cart"},
        { text: "我的淘宝", className: "icon-my", link: "/myaccount"},
        { text: "更多", className: "icon-more", link: "/more"}
      ]
    }
  }
}
</script>

<style lang="scss">
  $color: #666;

  #bottom-tool{
    position: relative;
    z-index: 9;
    padding: .05rem;
    background: #fff;

    a{
      text-decoration: none;
    }
  }
  .tool-item{
    width: 20%;
    float: left;
    text-align: center;
  }
  .tool-item .iconfont{
    margin-bottom: .04rem;
    font-size: .22rem;
    color: $color;
  }
  .tool-item .text{
    -webkit-text-size-adjust: none;
    color: $color;
    line-height: 1.2;
    font-size: .1rem;
  }
</style>



// WEBPACK FOOTER //
// bottomTool.vue?32a7eb7f